<div style="position: relative;">
  <div id="busy-overlay" class="component-overlay" *ngIf="isBusy">
    <div class="center" *ngIf="isBusy">
      <mat-spinner color="accent" [diameter]="48"></mat-spinner>
    </div>
  </div>
  <button mat-button color="accent" (click)="addNewCsSetupSection()">
    <mat-icon>add</mat-icon>
    LADESTATION HINZUFÜGEN
  </button>
  <button mat-button *ngIf="addElectricityMeterUnitPossible" color="accent" (click)="addNewElectricityMeterUnit()">
    <mat-icon>add</mat-icon>
    ZÄHLERANSCHLUSSSÄULE HINZUFÜGEN
  </button>

  <div *ngIf="hasCsSetups" style="margin-top: 24px;">
    <h2 style="margin-bottom: -12px;">Ladestationen</h2>
    <app-cs-setup *ngFor="let csSetupInfo of csSetupInfos"
                              [csSetupInfo]="csSetupInfo" 
                              [chargingStations]="chargingStations"
                              (updatedCsSetupSection)="onUpdatedCsSetupSection($event)"
                              (removeCsSetupSectionRequest)="removeCsSetupSection($event)"
                              (markEmuForDeletion)="markEmuForDeletion($event)"
                              (unmarkEmuForDeletion)="unmarkEmuForDeletion($event)"></app-cs-setup>
  </div>
  
  <a id="lastCsSetup"></a>
  <div *ngIf="hasElectricityMeterUnitEntry" style="margin-top: 24px;">
    <h2 style="margin-bottom: -12px;">Zähleranschlusssäule</h2>
    <app-electricity-meter-unit [electricityMeterUnits]="possibleElectricityMeterUnits"
                                [electricityMeterUnitInfo]="electricityMeterUnitInfo"
                                [isMarkedForDeletion]="emuIsMarkedForDeletion"
                                (removeElectricityMeterUnitRequest)="removeElectricityMeterUnit()"
                                (updatedElectricityMeterUnit)="onUpdatedElectricityMeterUnit($event)"></app-electricity-meter-unit>
  </div>
</div>
